import { REF_CODE_SEPARATOR } from "../constants/refCode.constants";

export const createRefCode = (refCode: string, ...args: (number | string)[]) =>
  [refCode, ...args.map((arg) => arg?.toString())].join(REF_CODE_SEPARATOR);
